// Cloudflare Images Configuration
// Profile + banner URLs are brand-scoped via brandConfig (not shared CF image IDs).
import {
  BRAND_PROFILE_IMAGE_URL,
  BRAND_BANNER_IMAGE_URL,
} from "@/lib/brandConfig";

export const CLOUDFLARE_CONFIG = {
  // Account ID from API URL
  ACCOUNT_ID: "bfb1a679ca6faf7c85a4350b05feb469",

  /**
   * @deprecated Prefer BRAND_PROFILE_IMAGE_URL / HEADER_PROFILE_IMAGE_URL.
   * Legacy shared image ID — wrong creator on multi-brand forks.
   */
  HEADER_IMAGE_ID: "1b0c6841-2a9f-45dd-a3a2-e2a3e60f6600",

  /**
   * @deprecated Prefer BRAND_BANNER_IMAGE_URL / BANNER_IMAGE_URL.
   */
  BANNER_IMAGE_ID: "9fdc1148-5ac5-48d3-2a3a-6ce149481300",

  // Payment Provider Logos (PNG format with transparent background)
  STRIPE_LOGO_ID: "9df325db-b5ab-4af3-6b6f-7488c5ae3800",
  COINBASE_LOGO_ID: "9df325db-b5ab-4af3-6b6f-7488c5ae3800",

  // Cloudflare Account Hash (Delivery Hash)
  ACCOUNT_HASH: "N5r9mtOgBIolYeX8w64oqg",

  getImageUrl: (imageId: string, variant: string = "public"): string => {
    const envAccountHash = import.meta.env.VITE_CLOUDFLARE_ACCOUNT_HASH;
    const accountHash = envAccountHash || CLOUDFLARE_CONFIG.ACCOUNT_HASH;
    return `https://imagedelivery.net/${accountHash}/${imageId}/${variant}`;
  },

  VARIANTS: {
    public: "public",
    thumbnail: "thumbnail",
    avatar: "avatar",
    small: "small",
    medium: "medium",
    large: "large",
  },
} as const;

/** Avatar circular — brandConfig (Ana Cloudinary por defecto). */
export const HEADER_PROFILE_IMAGE_URL = BRAND_PROFILE_IMAGE_URL;

/** Banner landscape — brandConfig. */
export const BANNER_IMAGE_URL = BRAND_BANNER_IMAGE_URL;

// Payment provider logo URLs (still Cloudflare Images — payment logos, not creator)
export const STRIPE_LOGO_URL = CLOUDFLARE_CONFIG.getImageUrl(
  CLOUDFLARE_CONFIG.STRIPE_LOGO_ID,
  "public",
);

export const COINBASE_LOGO_URL = CLOUDFLARE_CONFIG.getImageUrl(
  CLOUDFLARE_CONFIG.COINBASE_LOGO_ID,
  "public",
);
